import availability from "./components/availability.jst";
import loading from "./components/loading.jst";
import filters from "./components/filters.jst";
import auth from "./components/auth.jst";
import authPass from "./components/authPass.jst";
import jobCard from "./components/jobCard.jst";
import jobCardNew from "./components/jobCardNew.jst";
import login from "./components/login.jst";
import signup from "./components/signup.jst";

export default {
    Availability: availability,
    Loading: loading,
    Filters: filters,
    Auth: auth,
    AuthPass: authPass,
    JobCard: jobCard,
    JobCardNew: jobCardNew,
    Login: login,
    SignUp: signup,
};
